import { QueryBuilder, migrate } from 'vet-bones/utils/queryBuilder';

import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

type OldModelRule = {
  id: string;
  models: string[];
  name: string;
  ifClause: QueryBuilder;
  thenClause: QueryBuilder;
};

/**
 *  Migration to upgrade rules to Query Builder v6
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v52 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v52Projects(prevState.projects);
  }

  return nextState;
};

const v52Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    if (!project.diagram) {
      projectsById[projectId] = project;
      return;
    }

    projectsById[projectId] = {
      ...project,
      diagram: {
        ...project.diagram,
        model: {
          ...project.diagram.model,
          modelData: {
            ...project.diagram.model.modelData,
            rulesById: Object.entries(
              project.diagram.model.modelData.rulesById as Record<
                string,
                OldModelRule
              >
            ).reduce<Record<string, OldModelRule>>((acc, [ruleId, rule]) => {
              acc[ruleId] = {
                ...rule,
                ifClause: migrate(rule.ifClause),
                thenClause: migrate(rule.thenClause),
              };
              return acc;
            }, {}) as any,
          },
        },
      },
    };
  });

  return { ...prevProjectsState, projectsById };
};
